import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationUserGroupRoleBindingBatchCreateArgs,
  MutationUserGroupRoleBindingUpdateArgs,
  Role,
  UserGroupRoleBinding,
  UserRoleBinding,
} from "types/generated";

type UserGroupRoleBindingCreateData = {
  userGroupRoleBindingBatchCreate: Pick<UserRoleBinding, "id">[];
};

export const USER_GROUP_ROLE_BINDING_BATCH_CREATE: TypedDocumentNode<
  UserGroupRoleBindingCreateData,
  MutationUserGroupRoleBindingBatchCreateArgs
> = gql`
  mutation UserGroupRoleBindingBatchCreate($input: UserGroupRoleBindingBatchInput!) {
    userGroupRoleBindingBatchCreate(input: $input) {
      id
    }
  }
`;

type UserGroupRoleBindingUpdateData = {
  userGroupRoleBindingUpdate: Pick<UserRoleBinding, "id">;
};

export const USER_GROUP_ROLE_BINDING_UPDATE: TypedDocumentNode<
  UserGroupRoleBindingUpdateData,
  MutationUserGroupRoleBindingUpdateArgs
> = gql`
  mutation UserGroupRoleBindingUpdate($id: ID!, $input: UserGroupRoleBindingInput!) {
    userGroupRoleBindingUpdate(id: $id, input: $input) {
      id
    }
  }
`;

type UserGroupRoleBindingsData = {
  managedUserGroup: {
    id: string;
    userRoleBindings: UserGroupRoleBinding[];
  };
  roles: Pick<Role, "id" | "name">[];
};

export const USER_GROUP_ROLE_BINDINGS_WITH_ROLES: TypedDocumentNode<UserGroupRoleBindingsData> = gql`
  query UserGroupRoleBindingsWithRoles($id: ID!) {
    managedUserGroup(id: $id) {
      id
      userRoleBindings {
        id
        roleID
        spaceID
        userGroupID
      }
    }
    roles {
      id
      name
    }
  }
`;
